import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

const addCriteria = gql`
mutation addCriteria($title: String!, $importance: Int!, $createdate: DateTime!, $updatedate: DateTime!, $surveyId: ID) {
  createCriteria(title: $title, importance: $importance, createdate: $createdate, updatedate: $updatedate, surveyId: $surveyId) {
    id,
    title,
    createdate
  }
}`;

const editCriteria = gql`
mutation updateCriteria($id: ID!, $title: String!, $importance: Int!, $updatedate: DateTime!) {
  updateCriteria(id: $id, title: $title, importance: $importance, updatedate: $updatedate) {
    id,
    title
  }
}`;

const editOption = gql`
mutation updateOption($id: ID!, $title: String!, $importance: Int!, $updatedate: DateTime!) {
  updateOption(id: $id, title: $title, importance: $importance, updatedate: $updatedate) {
    id,
    title
  }
}`;

const deleteCriteria = gql`
mutation deleteCriteria($id: ID!) {
  deleteCriteria(id: $id) {
    id
  }
}`;

const addOption = gql`
mutation addOption($title: String!, $importance: Int!, $createdate: DateTime!, $updatedate: DateTime!, $criteriaId: ID) {
  createOption(title: $title, importance: $importance, createdate: $createdate, updatedate: $updatedate, criteriaId: $criteriaId) {
    id,
    title,
    createdate
  }
}`;



const getCriteria = gql`
query getCriteria($id: ID) {
  Criteria(id:$id){
    id,
    title,
    importance,
    options {
      id,
      title,
      importance
    }
  }
}
`;

@Injectable()
export class CriteriaService {



  constructor(private apollo: Apollo) { }

  addNewCriteria(title: string, importance: number, surveyId: string) {
    return this.apollo.mutate({
      mutation: addCriteria,
      variables: {
        title: title,
        importance: importance,
        surveyId: surveyId,
        createdate: new Date,
        updatedate: new Date,
      }
    }).map(({ data }: any) => data);
  }

  editCriteria(criteriaId: string, title: string, importance: number) {
    return this.apollo.mutate({
      mutation: editCriteria,
      variables: {
        id: criteriaId,
        title: title,
        importance: importance,
        updatedate: new Date,
      }
    }).map(({ data }: any) => data);
  }

  editOption(optionId: string, title: string, importance: number) {
    return this.apollo.mutate({
      mutation: editOption,
      variables: {
        id: optionId,
        title: title,
        importance: importance,
        updatedate: new Date,
      }
    }).map(({ data }: any) => data);
  }

  deleteCriteria(criteriaId: string) {
    return this.apollo.mutate({
      mutation: deleteCriteria,
      variables: {
        id: criteriaId,
      }
    }).map(({ data }: any) => data);
  }

  addNewOption(title: string, importance: number, criteriaId: string) {
    return this.apollo.mutate({
      mutation: addOption,
      variables: {
        title: title,
        importance: importance,
        criteriaId: criteriaId,
        createdate: new Date,
        updatedate: new Date,
      }
    }).map(({ data }: any) => data);
  }

  // delete criterias by passing many Ids of one criteria
  buildDeleteAnswers(args: Array<string>) {
    let index = 1;
    let deleteAnswerString = `mutation {`;

    args.forEach(answerId => {
      deleteAnswerString += `
      deleteAnswer${index}: deleteAnswer(id: "${answerId}") {
          id
      }`;
      index++;
    });
    deleteAnswerString += `}`;
    return deleteAnswerString;
  }
  deleteAnswers(ids: Array<string>) {
    const query = this.buildDeleteAnswers(ids);
    const deleteAnswers: any = gql`${query}`;
    return this.apollo.mutate({
      mutation: deleteAnswers,
    }).map(({ data }: any) => data);
  }

  // delete options by passing many Ids of one criteria
  buildDeleteOptions(args: Array<string>) {
    let index = 1;
    let deleteOptionString = `mutation {`;

    args.forEach(optionId => {
      deleteOptionString += `
      deleteOption${index}: deleteOption(id: "${optionId}") {
          id,
          title,
      }`;
      index++;
    });
    deleteOptionString += `}`;
    return deleteOptionString;
  }
  deleteOptions(ids: Array<string>) {
    const query = this.buildDeleteOptions(ids);
    const deleteOptions: any = gql`${query}`;
    return this.apollo.mutate({
      mutation: deleteOptions
    }).map(({ data }: any) => data);
  }

  // page: editCriteria delete options and answers
  buildDeleteAnswers2(args: Array<string>) {
    let index = 1;
    let deleteAnswerString = ``;

    args.forEach(answerId => {
      deleteAnswerString += `
      deleteAnswer${index}: deleteAnswer(id: "${answerId}") {
          id
      }`;
      index++;
    });
    deleteAnswerString += ``;
    return deleteAnswerString;
  }
  buildDeleteOptions2(args: Array<string>) {
    let index = 1;
    let deleteOptionString = ``;

    args.forEach(optionId => {
      deleteOptionString += `
      deleteOption${index}: deleteOption(id: "${optionId}") {
          id,
          title,
      }`;
      index++;
    });
    deleteOptionString += ``;
    return deleteOptionString;
  }
  buildDeleteCriterias2(args: Array<string>) {
    let index = 1;
    let deleteCriteriaString = ``;

    args.forEach(criteriaId => {
      deleteCriteriaString += `
      deleteCriteria${index}: deleteCriteria(id: "${criteriaId}") {
          id,
          title,
      }`;
      index++;
    });
    deleteCriteriaString += ``;
    return deleteCriteriaString;
  }
  buildEditOption(id, title, importance) {
    const nowDate = new Date().toISOString();
    let editOptionString = ``;
    editOptionString = `
      updateOption${id}: updateOption(id: "${id}", title: "${title}", importance: ${importance}, updatedate:  "${nowDate}") {
          id,
          title
      }`;
    editOptionString += ``;
    return editOptionString;
  }
  buildAddOption(index, criteriaId, title, importance) {
    const nowDate = new Date().toISOString();
    let addOptionString = ``;
    addOptionString = `
      addOption${index}: createOption(criteriaId: "${criteriaId}", title: "${title}", importance: ${importance}, createdate: "${nowDate}", updatedate: "${nowDate}") {
          id,
          title
      }`;
    addOptionString += ``;
    return addOptionString;
  }
  mutateEditCriteria(mutateString: string) {
    const mutateEditCriteria: any = gql`${mutateString}`;
    return this.apollo.mutate({
      mutation: mutateEditCriteria
    }).map(({ data }: any) => data);
  }

  getCriteriaData(criteriaId: string) {
    return this.apollo.watchQuery<{ CriteriaDetails }>({
      query: getCriteria,
      variables: {
        id: criteriaId
      },
      pollInterval: 1000,
    }).valueChanges.map(({ data }: any) => data);
  }

  // delete criterias by passing many Ids of one vision
  buildDeleteCriterias(args: Array<string>) {
    let index = 1;
    let deleteCriteriasString = `mutation {`;

    args.forEach(criteriaId => {
      deleteCriteriasString += `
      deleteCriteria${index}: deleteCriteria(id: "${criteriaId}") {
          id
      }`;
      index++;
    });
    deleteCriteriasString += `}`;
    return deleteCriteriasString;
  }
  deleteCriterias(ids: Array<string>) {
    const query = this.buildDeleteCriterias(ids);
    const deleteCriterias: any = gql`${query}`;
    return this.apollo.mutate({
      mutation: deleteCriterias
    }).map(({ data }: any) => data);
  }

}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/services/criteria.service.ts